require('../../modules/es6.number.parse-float');
module.exports = parseFloat;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/parse-float.js
// module id = 1650
// module chunks = 1